export default __webpack_public_path__ + "static/blogmain-ba5573befb25d14f921298d2294a8532.png";